import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaFilePdf } from 'react-icons/fa';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Paper, Dialog, DialogActions, DialogContent, DialogTitle, Typography, TablePagination, MenuItem, Select, InputLabel, FormControl, TextField, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CompanyList = () => {
  const [companies, setCompany] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null); // Seçilen kullanıcıyı tutacak state
  const [page, setPage] = useState(0); // Sayfa numarası
  const [rowsPerPage, setRowsPerPage] = useState(10); // Sayfa başına gösterilecek öğe sayısı
  const [openAuthorizeDialog, setOpenAuthorizeDialog] = useState(false);
  const [openAuthorizeDialog2, setOpenAuthorizeDialog2] = useState(false);
  const [searchName, setSearchName] = useState(''); // İsim araması için state
  const [searchEmail, setSearchEmail] = useState(''); // E-posta araması için state
  const [filterStatus, setFilterStatus] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get('https://kariyer.biyomed.net/api/companies/getAll');

        const sortedCompanies = response.data.companies.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setCompany(sortedCompanies);
        console.log(sortedCompanies)
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users:', error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleDownload = (pdfData, fileName) => {
    if (pdfData && pdfData.startsWith('data:application/pdf;base64,')) {
      const base64Data = pdfData.split('base64,')[1];  // Base64 verisini ayıklama

      const pdfBlob = new Blob([new Uint8Array(atob(base64Data).split("").map(c => c.charCodeAt(0)))], { type: 'application/pdf' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(pdfBlob);

      link.href = url;
      link.download = fileName; // Kullanıcının indireceği dosya adı
      link.click();

      // URL'yi serbest bırak
      URL.revokeObjectURL(url);
    } else {
      console.error("Geçersiz Base64 verisi:", pdfData);
      alert("Geçersiz PDF verisi.");
    }
  };

  const handleOpenDialog = (company) => {
    setSelectedUser(company); // Seçilen kullanıcıyı set et
    setOpenDialog(true); // Dialog'u aç
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Dialog'u kapat
    setSelectedUser(null); // Seçilen kullanıcıyı sıfırla
  };

  const handleApprove = async (companyId, companyEmail) => {
    try {
      const response = await axios.put('https://kariyer.biyomed.net/api/companies/updateStatus', {
        company_id: companyId, // user_id'yi body olarak gönderiyoruz
        company_email: companyEmail
      },
        { withCredentials: true });
      alert(response.data.message); // "User status updated to verified."
      window.location.href = '/admin/firmalar'
      // Status güncellendikten sonra kullanıcı verilerini güncellemek için tekrar GET isteği gönderebilirsiniz
    } catch (error) {
      console.error('Error updating user status:', error);
      alert('Onaylama işlemi sırasında bir hata oluştu.');
    }
  };

  const filteredCompanies = companies.filter(company => {
    return (
      company.company_name.toLowerCase().includes(searchName.toLowerCase()) &&
      company.email.toLowerCase().includes(searchEmail.toLowerCase()) &&
      (filterStatus === '' || company.status === filterStatus) &&
      (filterDate === '' || new Date(company.created_at).toISOString().split('T')[0] === filterDate)
    );
  });


  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Sayfa değiştirildiğinde yeni sayfa numarasını set et
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Sayfa başına gösterilecek öğe sayısını güncelle
    setPage(0); // Sayfa başına öğe sayısı değiştiğinde sayfayı sıfırlayın
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, filteredCompanies.length - page * rowsPerPage);


  const handleOpenAuthorizeDialog = (company) => {
    setSelectedUser(company);
    if (company.user_type === "Dernek") {
      setOpenAuthorizeDialog2(true);
    } else {
      setOpenAuthorizeDialog(true);
    }

  };

  const handleCloseAuthorizeDialog = () => {
    setOpenAuthorizeDialog(false);
    setSelectedUser(null);
  };

  const handleCloseAuthorizeDialog2 = () => {
    setOpenAuthorizeDialog2(false);
    setSelectedUser(null);
  };

  const handleAuthorizeCompany = async () => {
    if (!selectedUser) return;

    try {
      const response = await axios.put('https://kariyer.biyomed.net/api/companies/updatePermission', {
        company_id: selectedUser.id,
        company_email: selectedUser.email,
        user_type: selectedUser.user_type
      }, { withCredentials: true });

      alert(response.data.message);
      window.location.href = '/admin/firmalar'
      setOpenAuthorizeDialog(false);
    } catch (error) {
      console.error('Yetkilendirme hatası:', error);
      alert('Yetkilendirme işlemi sırasında bir hata oluştu.');
    }
  };

  const handleDeleteUser = async (companyId, Email) => {
    const confirmDelete = window.confirm("Bu kullanıcıyı silmek istediğinizden emin misiniz?");

    if (!confirmDelete) {
      return; // Eğer kullanıcı iptal ederse işlemi durdur
    }

    try {
      await axios.post("https://kariyer.biyomed.net/api/admin/deleteCompany", { company_id: companyId, email: Email }, {
        withCredentials: true, // Cookie gönderimi için
      });
      alert("Hesap başarıyla silindi ve kullanıcıya e-posta gönderildi.");
      window.location.href = '/admin/firmalar';
    } catch (error) {
      console.error("Hesap silme işlemi başarısız:", error);
      const errorMessage = error.response?.data?.message || "Bilinmeyen bir hata oluştu. Lütfen tekrar denemeden önce çıkış yapıp tekrar admin girişi yapınız.";
      alert(`Hesap silme işlemi başarısız: ${errorMessage}`);
    }
  };


  if (loading) {
    return <div>Yükleniyor Lütfen Bekleyiniz...</div>;
  }

  return (
    <div>
      <h2 style={{ marginBottom: 30 }} >Firma Kayıt Listesi</h2>
      <TextField
        label="Firma İsimiyle Ara"
        variant="outlined"
        fullWidth
        value={searchName}
        onChange={(e) => setSearchName(e.target.value)}
        style={{ marginBottom: 20, maxWidth: 200, marginLeft: 20 }}
      />
      <TextField
        label="E-posta ile Ara"
        variant="outlined"
        fullWidth
        value={searchEmail}
        onChange={(e) => setSearchEmail(e.target.value)}
        style={{ marginBottom: 20, maxWidth: 200, marginLeft: 20 }}
      />
      <FormControl style={{ minWidth: 200, marginLeft: 20, marginBottom: 20 }}>
        <InputLabel>Kayıt Durumu</InputLabel>
        <Select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
          <MenuItem value="">Tümü</MenuItem>
          <MenuItem value="notverified">Onaylanmadı</MenuItem>
          <MenuItem value="verified">Onaylandı</MenuItem>
        </Select>
      </FormControl>
      <TextField style={{ marginLeft: 20 }}
        label="Kayıt Tarihi"
        type="date"
        InputLabelProps={{ shrink: true }}
        value={filterDate}
        onChange={(e) => setFilterDate(e.target.value)}
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Firma ID</TableCell>
              <TableCell>Firma Adı</TableCell>
              <TableCell>E-Posta</TableCell>
              <TableCell>Telefon</TableCell>
              <TableCell>Detay Bilgileri</TableCell>
              <TableCell>Sirket websitesi</TableCell>
              <TableCell>Yetki</TableCell>
              <TableCell>Kayıt Tarihi</TableCell>
              <TableCell>Kayıt Durumu</TableCell>
              <TableCell>Sirket Dokumani</TableCell>
              <TableCell>İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCompanies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((company) => (
              <TableRow key={company.id}>
                <TableCell>{company.id}</TableCell>
                <TableCell>{company.company_name}</TableCell>
                <TableCell>{company.email}</TableCell>
                <TableCell>{company.phone}</TableCell>
                <TableCell style={{ color: company.details === 0 ? "red" : "green", fontWeight: "bold" }}>{company.details === 0 ? "Girilmemiş" : "Girilmiş"}</TableCell>

                <TableCell>
                  <a
                    href={company.website.startsWith("http") ? company.website : `https://${company.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {company.website}
                  </a>
                </TableCell>

                <TableCell sx={{ color: `${company.user_type === 'Normal' ? 'red' : 'green'}`, fontWeight: "bold" }}>{company.user_type === "Dernek" ? "Yetkili (Dernek)" : "Normal"}</TableCell>

                <TableCell>{new Date(company.created_at).toLocaleDateString()}</TableCell>
                <TableCell sx={{ color: `${company.status === 'notverified' ? 'red' : 'green'}`, fontWeight: "bold" }}>{company.status === 'notverified' ? 'Onaylanmadı' : "Onaylandı"}</TableCell>
                <TableCell>
                  {company.support_document && (
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => handleDownload(company.support_document, `${company.company_name}_support_document.pdf`)}
                      startIcon={<FaFilePdf />}
                    >
                      Belgeyi indir
                    </Button>
                  )}
                </TableCell>
                <TableCell>
                  {company.status === 'notverified' ? (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleApprove(company.id, company.email)}
                      >
                        Onayla
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteUser(company.id, company.email)}
                      >
                        Reddet ve Sİl
                      </Button>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Button
                        variant="contained"
                        color="info"
                        onClick={() => handleOpenDialog(company)} // Dialog'u aç
                      >
                        Detaylar
                      </Button>
                      <Button
                        variant="contained"
                        color={company.user_type === "Dernek" ? "warning" : "success"}
                        onClick={() => { handleOpenAuthorizeDialog(company) }}
                      >
                        {company.user_type === "Dernek" ? "Yetkİyİ Gerİ Al" : "Yetkİlendİr"}
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleDeleteUser(company.id)}
                      >
                        Sİl
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={10} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog - Detayları Gösterme */}
      {selectedUser && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Kullanıcı Detayları</DialogTitle>
          <DialogContent>
            <Typography variant="body1"><strong>Olusturma Tarihi:</strong> {selectedUser.created_at}</Typography>
            <Typography variant="body1"><strong>Geçici Şifre:</strong> {selectedUser.temp_password}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">Kapat</Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => navigate(`/admin/firma-detay/${selectedUser?.id}`)}
              disabled={selectedUser.details === 0 ? true : false} // ID yoksa butonu devre dışı bırak
            >
              Detay Bİlgİlerİ Görüntüle
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {/* Yerkilendirme */}
      <Dialog open={openAuthorizeDialog} onClose={handleCloseAuthorizeDialog}>
        <DialogTitle>Yetkilendirme Onayı</DialogTitle>
        <DialogContent>
          <Typography>
            Bu şirkete <strong>dernek yetkisini</strong> vermek istiyor musunuz?
          </Typography>
          <Typography>
            Dernek yetkisi ile bu şirket, diğer şirketler adına ilan oluşturabilir ve silebilir.
          </Typography>
          <Typography>
            Bunu onaylıyor musunuz?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAuthorizeDialog} color="secondary">İptal</Button>
          <Button onClick={handleAuthorizeCompany} color="primary">Onayla</Button>
        </DialogActions>
      </Dialog>

      {/* Yerkilendirme */}
      <Dialog open={openAuthorizeDialog2} onClose={handleCloseAuthorizeDialog2}>
        <DialogTitle>Yetkilendirme Onayı</DialogTitle>
        <DialogContent>
          <Typography>
            Bu şirketin <strong>dernek yetkisini</strong> geri almak istiyor musunuz?
          </Typography>
          <Typography>
            Dernek yetkisi ile bu şirket, diğer şirketler adına ilan oluşturabilir ve silebilir.
          </Typography>
          <Typography>
            Bunu onaylıyor musunuz?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAuthorizeDialog2} color="secondary">İptal</Button>
          <Button onClick={handleAuthorizeCompany} color="primary">Onayla</Button>
        </DialogActions>
      </Dialog>

      {/* Pagination */}
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={companies.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default CompanyList;
